import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './CalculatorDashboard.module.scss';
import {
  getApplicationDataHasFailed,
  getApplicationDataIsLoading
} from "../../../redux/modules/applicationData/applicationData.selectors";
import {getOnlyOWNRRMDs} from "../../../redux/modules/UserFunds/userFunds.selectors";
import {getEligibleForRMD, getRMDSummary} from "../../../redux/modules/RMD/RMDSetting.selectors";
import Loader from "../../Loader/Loader";
import ErrorPage from "../../../containers/landing/ErrorPage";
import Section from "../../DashboardLayout/Section/Section";
import FAQ from "../../DashboardLayout/FAQ/FAQ";
import CalculatorHeader from "./CalculatorHeader/CalculatorHeader";
import CalculatorSection from "./CalculatorSection/CalculatorSection";
import {initDashboardServiceCalls} from "../../../services";
import {clearShoppingCart} from "../../../redux/modules/shoppingCart/shoppingCart.module";

const CalculatorDashboard = (props) => {
  const isLoading = useSelector(getApplicationDataIsLoading);
  const hasRMD = useSelector(getOnlyOWNRRMDs);
  const rmdSummaryInfo = useSelector(getRMDSummary);
  const isEligible = useSelector(getEligibleForRMD);
  const showYTDColumns = rmdSummaryInfo.displayDistributionColumns;

  const { preRMDEligible } = rmdSummaryInfo;

  const dispatch = useDispatch();
  const hasError = useSelector(getApplicationDataHasFailed);
  let showFaq = true;

  const isPostLaunch = (dateAndTime) => {
    const currentDate = new Date();
    const launchDate = new Date(dateAndTime);
    return currentDate > launchDate;
  };

  useEffect(() => {
    initDashboardServiceCalls(dispatch);
    dispatch(clearShoppingCart());
  }, [dispatch]);

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Loader isVisible={true} />
      </div>
    );
  }

  if (hasError) {
    return <ErrorPage />;
  }

  return (
    <div className="dashboard-wrapper">
      <div className={styles['background']}>
        <div className={styles['container']}>
          {/* Header and Print Section*/}
          <CalculatorHeader />
          <Section>
            <CalculatorSection />
          </Section>
          <Section>
            <FAQ showFaq={showFaq} isPreRMDEligible={preRMDEligible} isPostLaunch={isPostLaunch} />
          </Section>
          <p>2914282</p>
        </div>
      </div>
      <style>
        {`
           .pre-rmd-eligible-section button {
            height: auto;
          }
      `}
      </style>
    </div>
  );
};

export default CalculatorDashboard;
